import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LocaleTh } from "./locales/th/localeTh";
import { LocaleEn } from "./locales/en/localeEn";

const resources = {
  th: {
    translation: {
      ...LocaleTh,
    },
  },
  en: {
    translation: {
      ...LocaleEn,
    },
  },
};

const current_lng = localStorage.getItem("lng");
i18n.use(initReactI18next).init({
  resources,
  lng: current_lng === "en" ? "en" : "th",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
